import { render, staticRenderFns } from "./DrillAiMath.vue?vue&type=template&id=b2e9e99c&scoped=true&lang=pug&"
import script from "./DrillAiMath.vue?vue&type=script&lang=ts&"
export * from "./DrillAiMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillAiMath.vue?vue&type=style&index=0&id=b2e9e99c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e9e99c",
  null
  
)

export default component.exports